import api from './index.js'

export default {

  // only super-admin can use
  getFirmwares() {
    return api.get('firmwares.json');
  },

  getFirmware(version) {
    const params = {
      version: version
    };
    return api.get('firmware.json', params);
  },

  getDevices() {
    return api.get('devices.json');
  },

  getDevice(nfcUid) {
    return api.get(`devices/${nfcUid}.json`);
  },

  updateDevice(payload) {
    return api.patch(`devices/${payload.nfc_uid}.json`, payload.params);
  }
}
